import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Popover, Button } from 'antd';
import {UserOutlined,} from '@ant-design/icons';
import TopbarDropdownWrapper from './TopbarDropdown.styles';
import authAction from '@app/redux/auth/actions';
import userRoles from '@app/constants/userRoles';

const { logout } = authAction;

export default function TopbarUser(props) {
    const dispatch = useDispatch();
    const profileInfo = useSelector((state) => state.Profile);
    const authInfo = useSelector((state) => state.Auth);
    const { currentUser, related } = authInfo;
    const [user, setUser] = React.useState(currentUser);
    const [visible, setVisibility] = React.useState(false);
    const [avatar, setAvatar] = React.useState(null);
    function handleVisibleChange() {
        setVisibility(visible => !visible);
    }
    React.useEffect(() => {
        if(profileInfo.infoAvatar){
            setAvatar(profileInfo.infoAvatar);
        }
    }, [profileInfo]);

    if(!user){
        return <></>
    }

    const content = (<TopbarDropdownWrapper className="isoUserDropdown">
        <div className="userName">
            {
                user.role_id == userRoles.admin && <><div className='userRole'>Administrador</div></>
            }
            {
                user.role_id == userRoles.user && <><div className='userRole'>Común</div></>
            }
            {
                user.role_id == userRoles.nominista && <><div className='userRole'>Nominista</div></>
            }
            {
                user.role_id == userRoles.gerente_nomina && <><div className='userRole'>Gerente de nomina</div></>
            }
        </div>
        {
            props.options && props.options.map((item, index) => (
                <Link key={`user-option-${index}`} className="isoDropdownLink" to={item.path}>
                    {item.title}
                </Link>
            ))
        }
        <div className="isoDropdownLink" onClick={() => dispatch(logout())}>
            Cerrar Sesión
        </div>
    </TopbarDropdownWrapper>);

    return (<Popover
            content={content}
            trigger="click"
            open={visible}
            onOpenChange={handleVisibleChange}
            // arrowPointAtCenter={true}
            placement="bottomLeft">
                {/* <div className="isoImgWrapper">
                    {(avatar && avatar.url) ? <img alt="user" src={avatar.url} /> : <img alt="user" src="/assets/images/avatardefault.jpeg" />}
                    <span className="userActivity online" />
                </div> */}
                <Button
                    type="text"
                    icon={<UserOutlined />}
                    style={{
                        fontSize: '16px',
                        width: 64,
                        height: 64,
                        float: 'right'
                    }}
                />
        </Popover>);
}
